/* 需求卡片：https://console.cloud.baidu-int.com/devops/icafe/issue/BE-EOP-13123/show */

import {getParams} from '@/utils/util';
import {API} from '../api';

// 激活实名所有认证方式submit接口
export const API_IS_ACTIVATED_NEW = {
    // 个人刷脸
    [API.personFaceSubmit]: true,
    // 个人证件认证
    [API.submitPersonCertificate]: true,
    // 个人银行卡
    [API.submitPerBank]: true,
    // 企业对公打款
    [API.submitCompTransfer]: true,
    // 企业充值认证
    [API.createPaymentProcess]: true,
    // 企业法人刷脸
    [API.legalLivingSubmit]: true,
    // 企业被授权人刷脸
    [API.legalAuthorizedLivingSubmit]: true,
    // pass同步实名
    [API.syncPass]: true,
};

export function getIsActivatedParam() {
    const hashSeg = location.hash ? location.hash.split('?') : [];
    const search = hashSeg.length > 1 ? hashSeg[1] : '';
    if (!search) {
        return null;
    }
    const query: any = getParams(search);
    if (+query?.isActivated) {
        return {
            isActivated: +query.isActivated,
        };
    }
    return null;
}

export function getNeedActivatedParam(url: string) {
    const needIsActivated = API_IS_ACTIVATED_NEW[url];
    if (needIsActivated) {
        const isActivated = getIsActivatedParam();
        return Promise.resolve(isActivated);
    }
    return Promise.resolve();
}
